import { post, getF2BObject } from 'api/api';
import { API } from '../consts';
import { GuestRegistration, Role } from './types/auth';
import { OwnerDetail } from './types/owner';
import { BASE_URL, useFetch, post as newPost, get as newGet } from 'utils/sdk';

// TODO: Remove
const getRandomPassword = () =>
  '1aA' +
  Array.from(new Array(16))
    .map(() => String.fromCharCode(Math.random() * 86 + 40))
    .join('');

export const createAnonymousSession = () => {
  const password = getRandomPassword();
  return post<GuestRegistration>('/services/guest/', {
    isAnonymous: true,
    isActive: true,
    password,
  }).then(({ data: { email } }) => newLogin(email, password));
};
// ============================================================

export const socialLoginOrCreateOwner = (platform, params = {}) => {
  const urlParams = params as any;
  const parsedParams = getF2BObject(urlParams);
  const queryParams = new URLSearchParams(parsedParams).toString();
  const url = `${API.root}auth/login/${platform}/${queryParams ? `?${queryParams}` : ''}`;
  window.location.href = url;
};

export const disconnectSocialProvider = (payload = {}) => {
  const url = '/auth/disconnect-backend/';
  return post(url, payload);
};
// ========= NEW AUTH APIS ============
interface JwtResponse {
  token: string;
}

interface MagicLinkConsumeResponse extends JwtResponse {
  is_new_host: boolean;
  // Sent for a new Host only.
  email?: string;
  owner_id?: number;
}

interface SignupRequest {
  firstName: string;
  email: string;
  phone: string;
  marketingCheckbox: boolean;
  captchaToken: string;
  toltPartnerId?: string;
  toltClickId?: string;
}

export const requestSignup = ({
  firstName,
  email,
  phone,
  marketingCheckbox,
  captchaToken,
  toltPartnerId,
  toltClickId,
}: SignupRequest) =>
  newPost(`${BASE_URL}jwt/signup/request/`, {
    first_name: firstName,
    email,
    phone,
    marketing_checkbox: marketingCheckbox,
    captcha_token: captchaToken,
    tolt_partner_id: toltPartnerId,
    tolt_click_id: toltClickId,
  });

export const newLogin = (email, password) => {
  const url = `${BASE_URL}jwt/login/`;
  const response = newPost<JwtResponse>(url, {
    email,
    password,
  });

  return response.then((res) => {
    localStorage.setItem('token', res.token);
    return res;
  });
};

export const requestMagicLink = ({ email }: { email: string }) =>
  newPost(`${BASE_URL}jwt/magic-link/request/`, { email });

export const consumeMagicLink = ({ token }: { token: string }) =>
  newPost<MagicLinkConsumeResponse>(`${BASE_URL}jwt/magic-link/consume/`, { token }).then((res) => {
    localStorage.setItem('token', res.token);
    return res;
  });

export const newLogout = () => {
  return newPost<OwnerDetail>(`${BASE_URL}jwt/logout/`).finally(() => {
    localStorage.removeItem('token');
  });
};

export interface MeResponse {
  user_id: number;
  owner_id?: number;
  email: string;
  role: Role;
  is_masqueraded: boolean;
  is_cohost: boolean;
  cohost_id: number | null;
}
export const fetchMe = () => {
  return newGet<MeResponse>(`${BASE_URL}jwt/me/`, {});
};

export const useSignedUser = () => useFetch<MeResponse>('jwt/me/');

// The SWR key of `useSignedUser`, for code that writes a new answer into the cache.
export const SIGNED_USER_KEY = `${BASE_URL}jwt/me/`;

// `useSignedUser` fires on mount with or without a token, so it 401s on public routes. Use this
// where the user is only wanted if already signed in - `isLoading` stays true when there is no token.
export const useSignedUserIfLoggedIn = () =>
  useFetch<MeResponse>(localStorage.getItem('token') ? 'jwt/me/' : undefined);

// ==========================================
